<template>
  <nav class="meta-nav">
    <div id="meta-nav__slected"></div>
    <router-link exact v-on:click.native="changeNav(0)" to="/dashboard/online-course">線上課程</router-link>
    <router-link exact v-on:click.native="changeNav(1)" to="/dashboard/center-course">面授課程</router-link>
  </nav>
</template>

<script>
export default {
  methods: {
    changeNav: function (index) {
      switch (index) {
        case 0:
          document.getElementById('meta-nav__slected').style.left = '0%'
          break
        case 1:
          document.getElementById('meta-nav__slected').style.left = '50%'
          break
        case 2:
          document.getElementById('meta-nav__slected').style.left = '100%'
          break
        case 3:
          document.getElementById('meta-nav__slected').style.left = '75%'
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.meta-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  background: #000;
  height: 4rem;
  color: #FFF;
  display: flex;

  #meta-nav__slected {
    width: 33%;
    height: 4rem;
    background: var(--color-blue-green);
    position: absolute;
    z-index: 100;
    transition: .3s;
  }

  > a {
    text-align: center;
    width: auto;
    flex: 1;
    line-height: 4rem;
    display: block;
    position: relative;
    z-index: 900;
    font-size: 1.5rem;
  }
}
</style>
